<mat-form-field [appearance]="appearance" [class.d-block]="extendWidth">
  @if (label) {
  <mat-label>{{ label }}</mat-label>
  }
  <input
    autocomplete="off"
    [class]="class"
    [matAutocomplete]="this.countryAutocomplete"
    [placeholder]="this.placeHolder"
    [readonly]="this.readonly"
    [tabIndex]="tabIndex"
    [formControl]="_formControl"
    [name]="this.name"
    aria-label="country"
    matInput
    type="text"
  />
  @if (this.loadingDB || this.loading) {
  <mat-progress-bar mode="buffer" />
  }
  <mat-autocomplete
    [panelWidth]="panelWidth ?? 0"
    #countryAutocomplete="matAutocomplete"
    (optionSelected)="onOptionsSelected($event)"
  >
    @for (country of filteredOptions; track country) {
    <mat-option [value]="country.name">
      <div class="d-flex">
        <mat-icon [svgIcon]="country?.alpha2Code?.toLowerCase() ?? ''" />
        <small class="country-list-item" [title]="getValueLabel(country)">{{ getValueLabel(country) }}</small>
      </div>
    </mat-option>
    }
  </mat-autocomplete>
  <div class="d-flex mr-1" matSuffix>
    @if (this.value) {
    <mat-icon [svgIcon]="this.value.alpha2Code.toLowerCase()" class="ml-1 s-20 secondary-text" />
    }
    <mat-icon class="ml-1" class="ml-1 cursor-pointer pos-rel" *ngIf="!!value" (click)="clear()">cancel</mat-icon>
  </div>
  @if (_formControl && _formControl.invalid) {
  <mat-error>{{ error }}</mat-error>
  } @if (hint) {
  <mat-hint>{{ hint }}</mat-hint>
  }
</mat-form-field>
